import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsComponent } from './reports.component';
import { BoxReportListComponent } from './box-report-list/box-report-list.component';
import { FileListComponent } from './file-list/file-list.component';
import { GenerateReportDialofComponent } from './generate-report-dialof/generate-report-dialof.component';
import { ReportsRoutingModule } from './reports-routing.module';
import { MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SidebarModule } from 'ng-sidebar';
import { SortDirectiveForReport } from './sort.directive';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
@NgModule({
  declarations: [
    ReportsComponent,
    SortDirectiveForReport,
    BoxReportListComponent,
    FileListComponent,
    GenerateReportDialofComponent,
  ],
  imports: [
    CommonModule,
    ReportsRoutingModule,
    MatTableModule,
    MatPaginatorModule,
    NgxPaginationModule,
    MatBottomSheetModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatDialogModule,
    MatTableModule,
    MatMenuModule,
    MatIconModule,
    MatProgressSpinnerModule,NgMultiSelectDropDownModule,
    MatRadioModule,
    ToastrModule.forRoot(),
    SidebarModule.forRoot(),
  ],
})
export class ReportsModule {}
